export interface Work {
  id: string;
  title: string;
  year: number;
  type: string;
  cover: string;
  director: string;
  cast: string[];
  releaseDate: string;
  runtime: string;
  synopsis: string;
  roleIds: string[];
}

export const works: Work[] = [
  {
    id: "harbor-letters",
    title: "海边的信",
    year: 2023,
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20quiet%20seaside%20town%20at%20dusk%20with%20a%20girl%20holding%20a%20letter%20facing%20the%20sea%2C%20muted%20deep%20blue%20and%20warm%20amber%20tones%2C%20soft%20film%20grain%2C%20minimalist%20editorial%20composition&width=800&height=1200&seq=work-harbor-letters&orientation=portrait",
    director: "中村悠介",
    cast: ["希岛爱理", "佐藤健吾", "小林奈绪"],
    releaseDate: "2023-09-15",
    runtime: "118 分钟",
    synopsis:
      "在海边小镇长大的少女真纪，偶然收到一封寄错地址的旧信。信中的文字像潮水般将她带回被遗忘的往事，她开始追寻信的真正主人，也重新审视自己与家人之间沉默多年的裂痕。影片以克制的镜头语言，讲述关于告别、原谅与重新出发的温柔故事。",
    roleIds: ["maki", "shota"],
  },
  {
    id: "winter-echo",
    title: "冬日回声",
    year: 2022,
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20snowy%20northern%20town%20with%20warm%20window%20lights%2C%20a%20solitary%20figure%20in%20a%20long%20coat%2C%20cold%20blue%20and%20soft%20orange%20contrast%2C%20atmospheric%20drama%20aesthetic%2C%20editorial%20minimal%20composition&width=800&height=1200&seq=work-winter-echo&orientation=portrait",
    director: "大野美咲",
    cast: ["希岛爱理", "高桥凉介", "松本千夏"],
    releaseDate: "2022-12-02",
    runtime: "全 10 集",
    synopsis:
      "北海道小镇的一间旧唱片店里，店主理纱每晚都会收到一通没有声音的电话。随着冬天深入，电话背后逐渐浮现出一段被小镇刻意遗忘的往事。理纱在追查真相的过程中，也慢慢与自己的过去和解。",
    roleIds: ["risa"],
  },
  {
    id: "kyoto-summer",
    title: "京都之夏",
    year: 2021,
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20traditional%20Kyoto%20alley%20in%20summer%20with%20lanterns%20and%20a%20girl%20in%20a%20light%20yukata%2C%20warm%20green%20and%20amber%20tones%2C%20soft%20sunlight%20through%20leaves%2C%20art%20house%20film%20aesthetic&width=800&height=1200&seq=work-kyoto-summer&orientation=portrait",
    director: "小林悠真",
    cast: ["希岛爱理", "山田连", "井上香织"],
    releaseDate: "2021-07-23",
    runtime: "106 分钟",
    synopsis:
      "大学期间独自来到京都暑期实习的纱织，住进一间老町屋。她与隔壁做和果子的青年相识，在蝉鸣与祭典之间度过了一个改变彼此的夏天。一段关于成长与选择的夏日物语。",
    roleIds: ["saori"],
  },
  {
    id: "silent-confession",
    title: "无声告白",
    year: 2024,
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%20and%20a%20girl%20holding%20an%20umbrella%2C%20deep%20blue%20and%20amber%20accents%2C%20moody%20thriller%20aesthetic%2C%20minimal%20editorial%20layout&width=800&height=1200&seq=work-silent-confession&orientation=portrait",
    director: "藤井玲",
    cast: ["希岛爱理", "中村隼", "木村优子"],
    releaseDate: "2024-04-12",
    runtime: "全 12 集",
    synopsis:
      "手语翻译员琴音受托为一起案件提供翻译支持，却在录音里听见了只有她才能察觉的谎言。随着案情推进，她发现自己翻译的不仅是语言，更是一个个被沉默保护起来的秘密。",
    roleIds: ["kotone"],
  },
  {
    id: "seventh-night",
    title: "第七个夜晚",
    year: 2020,
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lonely%20highway%20at%20night%20with%20a%20car%20headlights%20and%20a%20girl%20by%20the%20roadside%2C%20deep%20navy%20and%20amber%20contrast%2C%20suspense%20drama%20aesthetic%2C%20film%20grain%20texture&width=800&height=1200&seq=work-seventh-night&orientation=portrait",
    director: "中村悠介",
    cast: ["希岛爱理", "石田凉", "远藤真帆"],
    releaseDate: "2020-11-06",
    runtime: "124 分钟",
    synopsis:
      "连续七个夜晚，公路旁的加油站都会迎来同一位沉默的女顾客。第七夜，她留下了一只装满照片的信封。加油员少年由此卷入一场关于失踪与重逢的追寻。",
    roleIds: ["yuki"],
  },
  {
    id: "falling-sakura",
    title: "樱花落尽",
    year: 2019,
    type: "短片",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20of%20falling%20cherry%20blossoms%20over%20an%20empty%20school%20corridor%2C%20soft%20pink%20and%20pale%20blue%20tones%2C%20melancholic%20nostalgia%2C%20minimal%20art%20film%20composition&width=800&height=1200&seq=work-falling-sakura&orientation=portrait",
    director: "大野美咲",
    cast: ["希岛爱理", "佐藤葵"],
    releaseDate: "2019-04-01",
    runtime: "32 分钟",
    synopsis:
      "毕业前最后一个春天，两个女孩约定在樱花树下交换一封写给十年后自己的信。短片以极简的对话与大量的空镜，记录下青春将尽时那份无处安放的心情。",
    roleIds: ["aoi"],
  },
  {
    id: "city-lights",
    title: "城市之光",
    year: 2023,
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20modern%20city%20skyline%20at%20blue%20hour%20with%20a%20girl%20looking%20out%20from%20a%20rooftop%2C%20deep%20blue%20and%20warm%20orange%20city%20lights%2C%20urban%20drama%20aesthetic&width=800&height=1200&seq=work-city-lights&orientation=portrait",
    director: "藤井玲",
    cast: ["希岛爱理", "高桥凉介", "宫本遥"],
    releaseDate: "2023-01-20",
    runtime: "全 8 集",
    synopsis:
      "在都市独自打拼的电台主播凛，用深夜节目接住无数陌生人的孤独。当她自己的世界也开始动摇时，那些她曾安慰过的声音，反过来成为了支撑她的光。",
    roleIds: ["rin"],
  },
  {
    id: "chasing-wind",
    title: "追风的少女",
    year: 2022,
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20girl%20cycling%20along%20a%20coastal%20road%20at%20golden%20hour%2C%20wind%20in%20hair%2C%20warm%20amber%20and%20teal%20sky%2C%20youthful%20coming%20of%20age%20film%20aesthetic&width=800&height=1200&seq=work-chasing-wind&orientation=portrait",
    director: "小林悠真",
    cast: ["希岛爱理", "山田连", "小林奈绪"],
    releaseDate: "2022-06-10",
    runtime: "112 分钟",
    synopsis:
      "被诊断出心脏疾病的少女向日葵，决定在手术前完成一次沿海骑行。一路上她遇见形形色色的人，也在每一次踩下踏板的瞬间，重新定义什么是活着。",
    roleIds: ["himawari"],
  },
  {
    id: "rainy-season",
    title: "雨季不再来",
    year: 2021,
    type: "短片",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20of%20a%20rainy%20window%20with%20blurred%20city%20lights%20and%20a%20girl%20silhouette%2C%20soft%20blue%20and%20warm%20amber%20tones%2C%20melancholic%20minimal%20composition%20film%20grain&width=800&height=1200&seq=work-rainy-season&orientation=portrait",
    director: "大野美咲",
    cast: ["希岛爱理"],
    releaseDate: "2021-06-05",
    runtime: "28 分钟",
    synopsis:
      "一个雨季，一间无人光顾的洗衣店，一封始终没有寄出的信。短片以近乎无声的日常，讲述一个人如何与自己的遗憾平静共处。",
    roleIds: ["nagi"],
  },
  {
    id: "snow-country",
    title: "雪国来信",
    year: 2018,
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20snow%20covered%20village%20with%20a%20lone%20train%20and%20a%20girl%20in%20a%20red%20scarf%2C%20cold%20blue%20and%20warm%20red%20accent%2C%20literary%20period%20drama%20aesthetic&width=800&height=1200&seq=work-snow-country&orientation=portrait",
    director: "小林悠真",
    cast: ["希岛爱理", "石田凉", "井上香织"],
    releaseDate: "2018-12-21",
    runtime: "130 分钟",
    synopsis:
      "战后动荡年代，一名女子独自乘火车穿越雪国，去寻找丈夫信中提到的那个从未存在过的车站。影片改编自同名短篇，用雪的意象书写执念与告别。",
    roleIds: ["chiyo"],
  },
  {
    id: "starlight-promise",
    title: "星光下的约定",
    year: 2024,
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20girl%20and%20a%20boy%20under%20a%20starry%20night%20sky%20on%20a%20hilltop%2C%20deep%20navy%20sky%20with%20warm%20firefly%20lights%2C%20romantic%20drama%20aesthetic%2C%20soft%20bokeh&width=800&height=1200&seq=work-starlight-promise&orientation=portrait",
    director: "中村悠介",
    cast: ["希岛爱理", "中村隼", "松本千夏"],
    releaseDate: "2024-08-30",
    runtime: "116 分钟",
    synopsis:
      "天文台实习生遥与失意的作曲家偶然相遇，两人约定在每个流星季重逢。多年后，当其中一人即将离开这座城市，他们必须决定这个约定是否还值得延续。",
    roleIds: ["haruka"],
  },
  {
    id: "tender-lies",
    title: "温柔的谎言",
    year: 2020,
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20an%20elegant%20apartment%20interior%20with%20a%20girl%20looking%20at%20a%20mirror%2C%20warm%20amber%20and%20deep%20teal%20tones%2C%20psychological%20family%20drama%20aesthetic%2C%20minimal%20composition&width=800&height=1200&seq=work-tender-lies&orientation=portrait",
    director: "藤井玲",
    cast: ["希岛爱理", "木村优子", "远藤真帆"],
    releaseDate: "2020-05-15",
    runtime: "全 11 集",
    synopsis:
      "为了维持家庭的表面安稳，母亲、女儿与祖母各自守着一个小小的谎言。当这些谎言彼此交叠，一场关于体面与真心的家庭风暴悄然降临。",
    roleIds: ["misaki"],
  },
];

export function getWorkById(id: string): Work | undefined {
  return works.find((w) => w.id === id);
}

export const workTypes = ["电影", "电视剧", "短片"];